module.exports = {"341524100":"梅山镇","341524101":"麻埠镇","341524102":"青山镇","341524103":"燕子河镇","341524104":"天堂寨镇","341524105":"古碑镇","341524106":"吴家店镇","341524107":"斑竹园镇","341524108":"汤家汇镇","341524109":"南溪镇","341524110":"双河镇","341524111":"白塔畈镇","341524201":"张冲乡","341524202":"油坊店乡","341524203":"长岭乡","341524204":"槐树湾乡","341524205":"花石乡","341524206":"沙河乡","341524207":"桃岭乡","341524208":"果子园乡","341524209":"关庙乡","341524211":"全军乡","341524214":"铁冲乡","341524400":"现代产业园（经济开发区）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341524.json
// module id = 1048
// module chunks = 0